/**
 * Ordena un mapa {id -> objeto} por el campo `index` del objeto.
 * Los ítems sin campo `index` quedan al final (fallback para datos legacy).
 * Devuelve array de [id, objeto].
 */
export const sortByIndex = (map) =>
  Object.entries(map).sort(([, a], [, b]) => {
    const ai = a.index != null ? a.index : Infinity;
    const bi = b.index != null ? b.index : Infinity;
    return ai - bi;
  });

/**
 * Fisher-Yates shuffle. Devuelve un nuevo array barajado (no muta el original).
 */
export const shuffleArray = (arr) => {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};
